/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DigitalCertificateStatus model module.
 * @module model/DigitalCertificateStatus
 * @version 1.0.0
 */
class DigitalCertificateStatus {
    /**
     * Constructs a new <code>DigitalCertificateStatus</code>.
     * @alias module:model/DigitalCertificateStatus
     */
    constructor() { 
        
        DigitalCertificateStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DigitalCertificateStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DigitalCertificateStatus} obj Optional instance to populate.
     * @return {module:model/DigitalCertificateStatus} The populated <code>DigitalCertificateStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DigitalCertificateStatus();

            if (data.hasOwnProperty('in_progress')) {
                obj['in_progress'] = ApiClient.convertToType(data['in_progress'], 'Boolean');
            }
            if (data.hasOwnProperty('document_download_url')) {
                obj['document_download_url'] = ApiClient.convertToType(data['document_download_url'], 'String');
            }
            if (data.hasOwnProperty('can_request')) {
                obj['can_request'] = ApiClient.convertToType(data['can_request'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} in_progress
 */
DigitalCertificateStatus.prototype['in_progress'] = undefined;

/**
 * @member {String} document_download_url
 */
DigitalCertificateStatus.prototype['document_download_url'] = undefined;

/**
 * @member {Boolean} can_request
 */
DigitalCertificateStatus.prototype['can_request'] = undefined;






export default DigitalCertificateStatus;

